import _sectionClasses from './Page/Sections/index';
import _buttonClasses from '../DefaultButtons';
import StandardGroupView from '../1/Page/Groups/StandardGroupView';

const GroupViews = {
  standard: StandardGroupView //uses the same standard group as template 1
};

export {_sectionClasses, _buttonClasses, GroupViews};
